export default class AbstractBotaoTabela {
    tableId

    constructor(tableId) {
        this.tableId = tableId
    }

    getCallback() {
        throw new Error('getCallback n�o implementado')
    }

    getLabel() {
        throw new Error('getLabel n�o implementado')
    }

    getIcone() {
        throw new Error('getIcone n�o implementado')
    }

    getText() {
        const icon = `<i class='material-icons' style='font-weight: 600;'>${this.getIcone()}</i>`;
        const label = `<span class='d-none d-xxl-block'>${this.getLabel()}</span>`;
        return icon + label;
    }
}
